import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { LogOut, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';

const SessionBanner = () => {
  const { sessionExpired, dismissSessionExpired } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  if (!sessionExpired) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm" data-testid="session-expired-overlay">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-sm mx-4 text-center">
        <div className="w-14 h-14 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-4">
          <AlertCircle className="w-7 h-7 text-amber-600" />
        </div>
        <h3 className="text-lg font-bold text-slate-900 mb-2">{t('sessionExpired')}</h3>
        <Button
          onClick={() => {
            dismissSessionExpired();
            navigate('/login');
          }}
          className="w-full bg-blue-600 hover:bg-blue-700 mt-4"
          data-testid="session-reconnect-button"
        >
          {t('reconnect')}
        </Button>
      </div>
    </div>
  );
};

export default SessionBanner;
